module.exports = __webpack_public_path__ + "static/media/E5.d693440f.jpeg";